import styled, { css } from 'styled-components';

export const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  pointer-events: none;
  z-index: 0;
`;

export const CellGrid = styled.div`
  display: grid;
  width: 100%;
`;

export const Cell = styled.div`
  ${({ theme: { colors } }) => css`
    border: 1px dashed ${colors.brandDarkTint80};
    border-radius: 0.5rem;
    background: transparent;
    transition:
      background 0.1s ease,
      border-color 0.1s ease;

    &[data-highlighted='true'] {
      border-color: ${colors.brandPrimary};
      background: ${colors.brandPrimaryTint90};
    }
  `}
`;
